import {
  NotificationReportGranularity,
  NotificationReportRuleBreakdown,
  NotificationReportVolumeBucket,
  TRIGGER_RULE_LABELS,
} from "../../models/notification-logs";
import { TENANT_SERIES_COLORS } from "./benefitsMetricsPresentation";

export const MANUAL_SERIES_COLOR = TENANT_SERIES_COLORS[0];
export const AUTOMATIC_SERIES_COLOR = TENANT_SERIES_COLORS[1];

const CHART_SURFACE = "#ffffff";

export const formatPeriodLabel = (
  period: string,
  granularity: NotificationReportGranularity
): string => {
  const [year, month, day] = period.split("-");
  if (granularity === "month") {
    return `${month}/${year}`;
  }
  return `${day}/${month}`;
};

export const formatFailureRate = (rate: number): string =>
  `${(rate * 100).toFixed(1).replace(".", ",")}%`;

export const ruleLabel = (row: NotificationReportRuleBreakdown): string => {
  if (row.type === "MANUAL") {
    return "Envío manual";
  }
  return row.triggerRule ? TRIGGER_RULE_LABELS[row.triggerRule] : "Automática";
};

export const buildVolumeChartData = (
  volume: NotificationReportVolumeBucket[],
  granularity: NotificationReportGranularity
) => ({
  labels: volume.map((bucket) => formatPeriodLabel(bucket.period, granularity)),
  datasets: [
    {
      label: "Manual",
      data: volume.map((bucket) => bucket.manual),
      backgroundColor: MANUAL_SERIES_COLOR,
      borderColor: CHART_SURFACE,
      borderWidth: 2,
      borderRadius: 4,
      borderSkipped: false,
      stack: "notifications",
    },
    {
      label: "Automática",
      data: volume.map((bucket) => bucket.automatic),
      backgroundColor: AUTOMATIC_SERIES_COLOR,
      borderColor: CHART_SURFACE,
      borderWidth: 2,
      borderRadius: 4,
      borderSkipped: false,
      stack: "notifications",
    },
  ],
});

export const volumeChartOptions = {
  maintainAspectRatio: false,
  interaction: {
    mode: "index" as const,
    intersect: false,
  },
  plugins: {
    legend: {
      display: true,
      position: "top" as const,
      align: "start" as const,
      labels: { boxWidth: 16, boxHeight: 12, padding: 16, usePointStyle: false },
    },
    tooltip: {
      callbacks: {
        footer: (items: Array<{ parsed: { y: number } }>) => {
          const total = items.reduce((sum, item) => sum + (item.parsed?.y ?? 0), 0);
          return `Total: ${total}`;
        },
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: { display: false },
    },
    y: {
      stacked: true,
      beginAtZero: true,
      ticks: { precision: 0 },
    },
  },
};
